<template>
  <v-app id="inspire">
    <v-content class="login-frame">
      <v-container class="fill-height " fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 ml-5 ">
              <v-card-text>
                <p>{{ msg }}</p>
                <form>
                  <form-wrapper :validator="$v.form">
                    <div style="margin-bottom: 20px">
                      <form-summary />
                    </div>

                    <form-group name="passwod">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          :success="pasSucces"
                          :error="pasError"
                          outlined
                          v-bind="attrs"
                          v-model="form.password"
                          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="show1 ? 'text' : 'password'"
                          name="input-10-1"
                          label="Nueva contraseña"
                          hint="8 caracteres requeridos"
                          @input="$v.form.password.$touch()"
                          counter
                          @click:append="show1 = !show1"
                        />
                      </template>
                    </form-group>
                    <form-group name="repeatPasswod">
                      <template slot-scope="{ attrs }">
                        <v-text-field
                          :success="pasRepSucces"
                          :error="pasRepError"
                          outlined
                          v-bind="attrs"
                          v-model="form.repeatPassword"
                          :type="show1 ? 'text' : 'password'"
                          label="Repite la contraseña"
                          @input="$v.form.repeatPassword.$touch()"
                        />
                      </template>
                    </form-group>
                  </form-wrapper>
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  style="text-transform:none;"
                  color="#9ccc3c"
                  @click.prevent="submit"
                  :disabled="this.$v.$invalid"
                >
                  <span style="color:#fff"> Cambiar</span>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      show1: false,
      msg: "",
      username: "",
      form: {
        password: "",
        repeatPassword: "",
      },
    };
  },
  validations() {
    return {
      form: {
        password: { required, minLength: minLength(8) },
        repeatPassword: { sameAs: sameAs("password") },
      },
    };
  },
  mounted() {
    let token = this.getUrlParam("token", "");
    let data = { token };
    this.tokenVerifyForResetPass(data)
      .then((res) => {
        this.successActivation = true;
        this.msg = res["message"];
        this.username = res["username"];
      })
      .catch(() => {
        this.isError = true;
      });
  },
  methods: {
    ...mapActions("auth", {
      tokenVerifyForResetPass: "tokenVerifyForResetPass",
      updatePassword: "updatePassword",
    }),
    getUrlVars() {
      let vars = {};
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
        m,
        key,
        value
      ) {
        vars[key] = value;
      });
      return vars;
    },
    getUrlParam(parameter, defaultValue) {
      let urlParameter = defaultValue;
      if (window.location.href.indexOf(parameter) > -1) {
        urlParameter = this.getUrlVars()[parameter];
      }
      return urlParameter;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        let user = {
          username: this.username,
          password: this.form.password,
          password_confirmation: this.form.repeatPassword,
        };
        this.updatePassword(user)
          .then(() => {
            this.$router.push({
              name: "login",
            });
          })
          .catch((err) => {
            console.log(err.nonFieldErrors[0]);
          });
      }
    },
  },
  computed: {
    pasSucces() {
      if (this.$v.form.password.$model !== "") {
        if (this.$v.form.password.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    pasError() {
      if (this.$v.form.password.$model !== "") {
        if (this.$v.form.password.$invalid) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    pasRepSucces() {
      if (this.$v.form.repeatPassword.$model !== "") {
        if (this.$v.form.repeatPassword.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    pasRepError() {
      if (this.$v.form.repeatPassword.$model !== "") {
        if (this.$v.form.repeatPassword.$invalid) {
          return true;
        } else {
          return false;
        }
      } else {
        return null;
      }
    },
    succesDate() {
      if (this.$v.form.DateVal.$model !== "") {
        if (this.$v.form.DateVal.$invalid) {
          return false;
        } else {
          return true;
        }
      } else {
        return null;
      }
    },
    fromDateDisp() {
      return this.form.DateVal;
      // format/do something with date
    },
    end_at() {
      return null;
    },
  },
};
</script>

<style>
.login-frame {
  background-image: url("../../assets/img/backgrounds/fondoazul.png");
  background-position: center center;
  background-size: cover;
}
</style>
